var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3333 4H8.66667L8.66667 10H11.3333V4ZM14 6V2C14 0.895431 12.8061 0 11.3333 0H8.66667C7.19391 0 6 0.895431 6 2V6H2C0.895431 6 0 6.89543 0 8V13V18V20V25V27V34C0 35.1046 0.895432 36 2 36H34C35.1046 36 36 35.1046 36 34V27V25V20V18V13V8C36 6.89543 35.1046 6 34 6H30V2C30 0.895431 28.8061 0 27.3333 0H24.6667C23.1939 0 22 0.895431 22 2V6H14ZM32 18V13H27V18H32ZM25 18V13H19V18H25ZM17 18H11V13H17V18ZM17 20V25H11V20H17ZM19 25V20H25V25H19ZM17 27H11V32H17V27ZM19 32V27H25V32H19ZM27 27V32H32V27H27ZM27 20V25H32V20H27ZM9 18V13H4V18H9ZM4 20H9V25H4V20ZM4 32V27H9V32H4ZM27.3333 4V10H24.6667V4H27.3333Z",
    fill: "#FF6633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonCalendar);
export default __webpack_public_path__ + "static/media/lesson-calendar.4b36ad112dc3af087a81206f6ab04c1e.svg";
export { ForwardRef as ReactComponent };